import * as React from 'react';
import LoadingSpinner from './LoadingSpinner';
import { CompositeComponent } from './types';

interface LazyLoaderProps<TProps> {
    lazyLoadComponent: () => Promise<CompositeComponent<TProps>>;
    showLoader?: boolean;
}

export default function withLazyLoader<TProps>(
    options: LazyLoaderProps<TProps>,
    PlaceholderComponent?: CompositeComponent<any>
) {
    const Placeholder = PlaceholderComponent || LoadingSpinner;

    return class WithLazyLoaderComponent extends React.Component<
        TProps,
        { LazyComponent?: any }
    > {
        constructor(props: TProps) {
            super(props);
            this.state = {};
        }

        public componentDidMount() {
            if ((process as any).browser && !this.state.LazyComponent) {
                options
                    .lazyLoadComponent()
                    .then(LazyComponent => this.setState({ LazyComponent }));
            }
        }

        public render() {
            const { LazyComponent } = this.state;
            const { showLoader } = options;

            if (!LazyComponent) {
                return showLoader === false ? null : <Placeholder />;
            }

            return <LazyComponent {...this.props} />;
        }
    };
}



// WEBPACK FOOTER //
// ./src/client/components/withLazyLoader.tsx